// ─── SOLD OUT LABEL ──────────────────────────────────────────────────────────────────────────────────────────────
// How a sold-out product is shown everywhere (default storefront, Design Studio, Discover tiles, the seller's own list):
// the photo stays exactly as it is — never dimmed, greyed or covered, and no badge sits over it — and the words
// "Sold out" take the place of the add-to-cart button, in the same light-red tag the stock badges use (red text on
// #FEF3F2). When the store takes restock requests the label stays tappable and says so underneath.
export const SOLD_OUT_BG = "#FEF3F2";
export const SOLD_OUT_FG = "#B42318";
export const SOLD_OUT_BORDER = "#FDA29B";

// block = fills the card width like the add-to-cart button it replaces; otherwise a small inline tag beside the price.
export function SoldOutLabel({ block = false, height = 36, fontSize = 13, onRestock = null, hint = "Tap to request a restock", style }) {
  const base = {
    display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box",
    background: SOLD_OUT_BG, color: SOLD_OUT_FG, fontFamily: "inherit", fontWeight: 600, lineHeight: 1,
    ...(block
      ? { width: "100%", height, fontSize, border: `1px solid ${SOLD_OUT_BORDER}`, borderRadius: 4 }
      : { height: 28, padding: "0 10px", fontSize: 12, border: "none", borderRadius: 2, flexShrink: 0, whiteSpace: "nowrap" }),
    ...style,
  };
  if (!onRestock) return <div style={base}>Sold out</div>;
  return (
    <div style={{ width: block ? "100%" : "auto" }} onClick={(e) => e.stopPropagation()}>
      <button type="button" onClick={(e) => { e.stopPropagation(); onRestock(); }} aria-label="Sold out — request a restock" style={{ ...base, cursor: "pointer" }}>Sold out</button>
      {block && hint && <div style={{ fontSize: 11, color: "var(--ink-soft, #6B655D)", textAlign: "center", marginTop: 4, fontFamily: "inherit" }}>{hint}</div>}
    </div>
  );
}
